import { useParams } from 'react-router-dom';
import { RouteRedirect } from '@/routing/RouteRedirect';
import { useWorkAreaRouteRef } from '@/routing/workAreaRoute';
import { projectTaskPath } from '@/features/work-items/projectItemUrls';

/**
 * `/<work area>/-/holds` and `/<work area>/-/holds/<KEY>`, from before the Holds page was folded into
 * Tasks for me (T-0492, TF-22): the same work area's Tasks for me, with that item selected.
 *
 * `replace`, so Back does not return to an address that only redirects. A hold waiting on the reader
 * is a Tasks for me row; one that is not waiting on them is still on the item's own banner, where the
 * selected item opens.
 */
export function HoldsAddressRedirect() {
  const workArea = useWorkAreaRouteRef();
  const { itemKey } = useParams();
  return <RouteRedirect to={projectTaskPath(workArea ?? null, itemKey ?? null)} />;
}
